"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function DropboxIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "m6,1.95L0,5.719l6,3.769,6.001-3.769,6,3.769,6-3.769-6-3.769-6,3.769L6,1.95Z" }),
        react_1.default.createElement("path", { d: "m6,17.025L0,13.256l6-3.769,6.001,3.769-6.001,3.769Z" }),
        react_1.default.createElement("path", { d: "m12,13.256l6-3.769,6,3.769-6,3.769-6-3.769Z" }),
        react_1.default.createElement("path", { d: "m12,22.05l-6.001-3.769,6.001-3.769,6,3.769-6,3.769Z" })));
}
exports.default = DropboxIcon;
